import React, { FC } from "react";
import { ThemeProvider } from "styled-components";

export interface StyledThemeProviderProps {}

export const StyledThemeProvider: FC<StyledThemeProviderProps> = ({
  children,
}) => {
  return (
    <ThemeProvider
      theme={{
        color: {
          primary: "#323E4E",
          secondary: "#DBDDE0",
          active: "#242D39",
          icon: "#B2B4B3",
          divider: "#3D4857",
          headerBg: "#2D3846",
        },
        panelSection: {
          bg: "#3D4757",
          fontColor: "#BBBDC3",
        },
        canvas: {
          bg: "#e7e7e7",
        },
        layers: {
          bg: "#252e3a",
        },
      }}
    >
      {children}
    </ThemeProvider>
  );
};

export default StyledThemeProvider;
